export const editorConfiguration = {
  toolbar: {
    items: [
      'heading', 'fontColor', 'fontsize',
      'bold', 'italic', 'underline', 'strikethrough', 'link',
      'findAndReplace', 'highlight', 'insertTable',
      'alignment', 'numberedList', 'bulletedList', 'outdent', 'indent',
      'horizontalLine', 'undo', 'redo',
    ],
    shouldNotGroupWhenFull: true
  },
  indent: {
    offset: 1,
    unit: 'em'
  },
  outdent: {
    offset: 1,
    unit: 'em'
  },
  heading: {
    options: [
      {
        model: 'paragraph', view: 'p', title: 'Paragraph',
      },
      {
        model: 'heading1', view: 'h1', title: 'Heading 1',
      },
      {
        model: 'heading2', view: 'h2', title: 'Heading 2',
      },
      {
        model: 'heading3', view: 'h3', title: 'Heading 3',
      },
      {
        model: 'heading4', view: 'h4', title: 'Heading 4',
      },
      {
        model: 'heading5', view: 'h5', title: 'Heading 5',
      },
      {
        model: 'heading6', view: 'h6', title: 'Heading 6',
      }
    ]
  },
  fontSize: {
    options: [8, 10, 12, 14, 16, 18, 24, 26, 28]
  },
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'tableCellProperties',
    ],
  },
  link: {
    defaultProtocol: 'https://',
    addTargetToExternalLinks: true,
  },
  isReadOnly: false
};
